import { IndexFilter } from '~/core/features/indexFiltering/IndexFilter';
import { UpdateIndexFilterPayload_ControlsState } from '~/core/features/indexFiltering/types/indices.type';
import { State } from '../types/state';

const updateIndexFilterControls = (state: State, payload: UpdateIndexFilterPayload_ControlsState): State => {
    const indexFilter = new IndexFilter();

    return {
        ...state,
        controls: state.controls.map((querySet) => {
            if (querySet.querySet.identifier !== payload.querySetIdentifier) {
                return querySet;
            }

            return {
                ...querySet,
                indices: querySet.indices?.map((index) => {
                    if (index.identifier !== payload.indexIdentifier) {
                        return index;
                    }

                    return indexFilter.updateControlsState(index, payload.check);
                }),
            };
        }),
    };
};

export default updateIndexFilterControls;
